<template>
  <v-dialog :value="value" v-on:input="$emit('input', $event)" max-width="550px" :persistent="saving">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">{{ origName }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert :value="showErrorOnSave" type="error">{{ errorOnSave }}</v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                        v-model.trim="edited.name"
                        required
                        :rules="[required]"
                        label="Name"
                        :error-messages="errorMessages"
                        :disabled="saving"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <TranslatedImageInput v-model="edited.image" :original="section.image" :suggest="edited.name" :key="section.id" :aspect-ratio="60/71"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="save" :loading="saving">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { TranslatedSectionsApi } from '../common/api'
import { UPDATE_TRANSLATED_SECTION } from '../store/mutation-types'
import TranslatedImageInput from '@/components/TranslatedImageInput'

export default {
  components: { TranslatedImageInput },
  props: ['value', 'model'],
  data () {
    return {
      valid: false,
      saving: false,
      errorMessages: [],
      errorOnSave: 'Error has occurred while saving',
      showErrorOnSave: false,
      edited: this.defaultModel()
    }
  },
  computed: {
    section () {
      return this.model || {}
    },
    translation () {
      return this.model.translation || {}
    },
    origName () {
      return this.model ? this.model.name : ''
    },
    isNew () {
      return !this.translation.id
    }
  },
  watch: {
    value () {
      this.showErrorOnSave = false
      this.$refs.form.resetValidation()
      if (!this.value) {
        return
      }
      if (this.isNew) {
        this.edited = this.defaultModel()
      } else {
        this.edited = { ...this.translation }
      }
    }
  },
  methods: {
    defaultModel () {
      return {
        name: '',
        image: null,
        languageId: this.$store.state.dictionary.targetLanguage ? this.$store.state.dictionary.targetLanguage.id : null
      }
    },
    validate () {
      return this.$refs.form.validate()
    },
    close () {
      if (this.saving) {
        return
      }
      this.$emit('input', false)
    },
    async save () {
      if (this.saving) {
        return
      }
      if (!this.validate()) {
        return
      }
      this.showErrorOnSave = false
      this.saving = true
      try {
        const section = this.model
        if (this.isNew) {
          const { data } = await TranslatedSectionsApi.create(section, this.edited)
          this.$store.commit(UPDATE_TRANSLATED_SECTION, { section, translation: data })
        } else {
          const { data } = await TranslatedSectionsApi.update(section, this.edited)
          this.$store.commit(UPDATE_TRANSLATED_SECTION, { section, translation: data })
        }
        this.saving = false
        this.close()
      } catch (e) {
        this.saving = false
        this.showErrorOnSave = true
        console.error(e)
      }
    },
    required (value) {
      return !!value || 'Required.'
    }
  }
}
</script>
